import { lazy } from 'react';


export const FAQ = lazy(() => import('./FAQ'));
